import { components } from "@/api-schema";
import { isRelocationOrderTerminalStatus } from "./relocation-order-terminal-status";

type Vehicle = components["schemas"]["Vehicle"];

export function vehicleHasPendingRelocationOrder(vehicle: Vehicle): boolean {
  if (!vehicle.relocationOrders || vehicle.relocationOrders.length === 0) {
    return false;
  }

  return vehicle.relocationOrders.some((order) => !isRelocationOrderTerminalStatus(order.status));
}
